module.exports = __webpack_public_path__ + "img/Right-arrow.3a6757ef.svg";